import { useEffect } from "react";
import Lenis from "lenis";

import { FormModalProvider } from "@/lib/formContext";
import { SeoHead } from "@/i18n/Seo";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Workflow } from "@/components/sections/Workflow";
import { BeforeAfter } from "@/components/sections/BeforeAfter";
import { UseCases } from "@/components/sections/UseCases";
import { Pricing } from "@/components/sections/Pricing";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";
import { MobileBottomCTA } from "@/components/sections/MobileBottomCTA";
import { AccessFormModal } from "@/components/sections/AccessFormModal";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <FormModalProvider>
      <SeoHead page="home" path="" />
      <div className="marketing-homepage App min-h-screen bg-white">
        <Navbar />
        <main>
          <Hero />
          <Workflow />
          <BeforeAfter />
          <UseCases />
          <Pricing />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
        <MobileBottomCTA />
        <AccessFormModal />
      </div>
    </FormModalProvider>
  );
}
